@let data = toast();

<div class="flex items-center gap-3">
  <span [class]="classes().tile" aria-hidden="true">
    <vx-icon [name]="tileIcon()" size="sm" />
  </span>

  <span
    class="line-clamp-2 min-w-0 flex-1 text-sm font-medium tracking-tight text-zinc-50">
    {{ data.title }}
  </span>

  <div class="flex shrink-0 items-center">
    @if (data.menu; as toastMenu) {
      <vx-icon-button
        variant="ghost"
        tone="secondary"
        size="sm"
        [icon]="toastMenu.icon"
        [ariaLabel]="toastMenu.label"
        [vxTooltip]="toastMenu.label"
        [vxMenuTriggerFor]="menuPanel"
        (vxMenuOpened)="menuOpened.emit()"
        (vxMenuClosed)="menuClosed.emit()" />
      <ng-template #menuPanel>
        <vx-menu class="w-56">
          @for (group of toastMenu.groups; track $index) {
            @if (!$first) {
              <vx-menu-separator />
            }
            @if (group.label; as label) {
              <vx-menu-label>{{ label }}</vx-menu-label>
            }
            @for (item of group.items; track $index) {
              <vx-menu-item (triggered)="menuItemSelected.emit(item)">
                {{ item.label }}
              </vx-menu-item>
            }
          }
        </vx-menu>
      </ng-template>
    }
    <vx-icon-button
      icon="x"
      variant="ghost"
      tone="secondary"
      size="sm"
      [ariaLabel]="data.dismissLabel"
      (click)="dismissed.emit()" />
  </div>
</div>

@if (!compact() && (data.description || data.content)) {
  <div class="-mt-1 flex min-w-0 flex-col gap-1.5 ps-11 pe-1">
    @if (data.description; as text) {
      <span class="text-sm tracking-tight text-zinc-400">{{ text }}</span>
    }
    @if (data.content; as body) {
      <ng-container *ngComponentOutlet="body.component; inputs: body.inputs" />
    }
  </div>
}

@if (!compact() && (data.hint || data.action)) {
  <div class="flex min-w-0 items-center gap-3 ps-11 pe-1">
    <span class="min-w-0 flex-1 text-xs tracking-tight text-zinc-500">
      {{ data.hint }}
    </span>
    @if (data.action; as action) {
      <vx-button
        class="shrink-0"
        variant="solid"
        tone="secondary"
        size="sm"
        (click)="actionPressed.emit()">
        {{ action.label }}
      </vx-button>
    }
  </div>
}

@if (!compact() && data.duration; as ms) {
  <span
    aria-hidden="true"
    class="absolute inset-x-0 bottom-0 h-0.5 origin-left animate-toast-countdown bg-zinc-500/50 motion-reduce:hidden"
    [style.animation-duration.ms]="ms"
    [style.animation-play-state]="paused() ? 'paused' : 'running'"></span>
}
